export enum BaiduPlaceType {
  å®¾é¦ = 'hotel',
  äº¤éè®¾æ½ = 'transitStation',
  æè² = 'organization',
  å¬å¸ä¼ä¸ = 'organization',
  ç¾é£ = 'organization',
  éåº = 'hotel',
  è´­ç© = 'organization',
  çæ´»æå¡ = 'organization',
  ææ¸¸æ¯ç¹ = 'attractions',
  ä¸½äºº = 'organization',
  ä¼é²å¨±ä¹ = 'organization',
  è¿å¨å¥èº« = 'organization',
  æè²å¹è®­ = 'organization',
  æåä¼ åª = 'organization',
  å»ç = 'organization',
  æ±½è½¦æå¡ = 'organization',
  éè = 'organization',
  æ¿å°äº§ = 'organization',
  æ¿åºæºæ = 'organization',
  åºå¥å£ = 'organization',
  èªç¶å°ç© = 'organization',
}
